const pagesCockpitEn = {
  title: "Cockpit",
  header: {
    startOperationPackage: "Start operation package",
    action1: "Action 1",
    action2: "Action 2",
    recent: "Recent",
    chatPlaceholder: "Get your business operation done",
  },
  approvalTasks: {
    trayTitle: "Approval Tray",
    tableHeaders: {
      taskName: "Approval Task",
      dueDate: "Due Date",
      applicant: "Applicant",
      approvalFlow: "Approval Flow",
    },
    loading: "Loading approval tasks...",
    error: "Failed to fetch approval tasks",
    empty: "No pending approval tasks",
  },
  operationTasks: {
    title: "Ongoing Tasks",
    tabs: {
      today: "Due Today",
      week: "Due This Week",
      month: "Due This Month",
      hr: "HR Department",
    },
    loading: "Loading tasks...",
    error: "Failed to fetch tasks",
    empty: {
      noTasks: "No tasks are due.",
    },
  },
  detail: {
    loading: "Loading task details...",
    error: "Failed to fetch approval task",
    actions: {
      approve: "Approve (Mock)",
      reject: "Return (Mock)",
    },
  },
};

export default pagesCockpitEn;
